// extracted by mini-css-extract-plugin
export var cancelButton = "_q1-5";
export var content = "_q1-3";
export var createButton = "_q1-6";
export var drawerContainer = "_q1-0";
export var footer = "_q1-2";
export var header = "_q1-1";
export var orderFormColumn = "_q1-4";